import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { StringNull } from "../../../../types";
import { useNavigate } from "react-router-dom";

export type ResponseMembrosCheckin = {
  listAll: { id: number, descricao: StringNull }[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: { id: number, descricao: StringNull }
  pagina: number
  getSearchMinister: (e: any) => void
  pesquisaPorMinisterio: string
  params: { idsede: number } | undefined,
  clearParams: VoidFunction,
  alterParams: (value: any) => void;
  goToInfo: (idusuario: string | number) => void
}

const GetMainDados = (): ResponseMembrosCheckin => {

  const navigate = useNavigate()

  const [listSedes, setListSedes] = useState<{ id: number, descricao: StringNull }[]>([]);
  const [list, setList] = useState<{ id: number, descricao: StringNull }>();
  const [pagina, setPagina] = useState<number>(0);
  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');

  const [params, setParams] = useState<{ idsede: number }>();


  const alterParams = (value: any) => setParams({ idsede: value });

  const clearParams = () => setParams(undefined);

  const getSearchMinister = (event) => setPesquisaPorMinisterio(event?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const goToInfo = (idusuario: string | number) => {
    try {
      navigate(`/dash/usuario/${idusuario}`)
    } catch(error) {
      console.log(error)
    }
  }

  const reset = async () => {
   await getList();
  }

  const getWithParams = () => {
    api.get<{ id: number, descricao: StringNull }[]>('view/cadastro/crm/' + params?.idsede)
      .then(
        (sucesso) => {
          setListSedes(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<{ id: number, descricao: StringNull }[]>('view/cadastro/crm/0')
      .then(
        (sucesso) => {
          setListSedes(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, []);

  useMemo(() => {
    getList()
  }, [pagina])


  return {
    listAll: listSedes,
    reset,
    nextPagina,
    list,
    pagina,
    getSearchMinister,
    pesquisaPorMinisterio,
    getWithParams,
    params,
    clearParams,
    alterParams,
    goToInfo
  };
}

export default GetMainDados;
